import { SurveyCompletion } from "@/features/auth/graphql/generated";
import {
  ASSESSMENT_SURVEY_TYPES,
  AssessmentSurveyConfig,
  AssessmentSurveyGroup,
  AssessmentSurveyType,
} from "@/shared/constants/assessmentSurveys";
import { filter, find, includes, isEmpty } from "lodash";

// WISNIO survey types are local surveys (completed on external platform)
const WISNIO_SURVEY_TYPES = [
  AssessmentSurveyType.IPIP_NEO_BIG_5,
  AssessmentSurveyType.SHWARTZ_VALUES,
  AssessmentSurveyType.WISNIO_COMPETENCIES,
];

export const getAssessmentSurveys = (
  surveys: SurveyCompletion[],
  surveyTypes = ASSESSMENT_SURVEY_TYPES
) => {
  return filter(surveys, (survey) => includes(surveyTypes, survey.survey_type));
};

export const getIsLocalSurvey = (survey: SurveyCompletion) => {
  return includes(WISNIO_SURVEY_TYPES, survey.survey_type);
};

export const getResourceSurveyType = (config: AssessmentSurveyType[]) => {
  if (isEmpty(config)) {
    return AssessmentSurveyGroup.WISNIO;
  }
  // Check if any config has WISNIO survey type based on predefined WISNIO_SURVEY_TYPES
  const hasWisnioSurvey = find(config, (st) =>
    includes(WISNIO_SURVEY_TYPES, st)
  );
  if (hasWisnioSurvey) {
    return AssessmentSurveyGroup.WISNIO;
  }

  return AssessmentSurveyGroup.AP;
};
